import {ApikeyAction} from './actionType'

export const startUploadVideo = (formData: FormData): ApikeyAction => ({type: 'apikey/UPLOAD_VIDEO_START', formData})

export const endUploadVideo: ApikeyAction = {type: 'apikey/UPLOAD_VIDEO_END'}
